/**
 * Record fittizio usato per le anteprime della scheda template.
 *
 * Serve solo a far vedere all'admin come suona il testo con le variabili
 * risolte: non viene mai salvato né inviato. Le chiavi sono i nomi delle
 * variabili come compaiono in `available_variables` (graffe singole nei testi).
 */
export const PREVIEW_SAMPLE_VALUES: Record<string, string> = {
  client_first_name: 'Giulia',
  client_last_name: 'Bernardi',
  client_email: 'giulia.bernardi@example.com',
  td_first_name: 'Marco',
  td_last_name: 'Ferri',
  td_email: 'marco.ferri@example.com',
  agency_first_name: 'Nord',
  agency_last_name: 'Viaggi',
  agency_name: 'Nord Viaggi',
  payer_first_name: 'Giulia',
  payer_last_name: 'Bernardi',
  itinerary_title: 'Giappone in autunno',
  itinerary_id: '7f3c1a9e',
  travel_request_id: '2b8d4c10',
  payment_id: 'c91f7a22',
  destinations: 'Tokyo, Kyoto, Osaka',
  amount: '1.250,00',
  currency: 'EUR',
  due_date: '30/09/2026',
  days_overdue: '3',
  installment_label: 'Acconto',
  platform_fee_amount: '62,50',
  recorded_by_name: 'Marco Ferri',
  start_date: '12/10/2026',
  end_date: '24/10/2026',
};

/** Payload passato a `NotificationTemplateMapper` per l'anteprima della notifica. */
export const PREVIEW_SAMPLE_PAYLOAD = {
  client_first_name: PREVIEW_SAMPLE_VALUES.client_first_name,
  client_last_name: PREVIEW_SAMPLE_VALUES.client_last_name,
  td_first_name: PREVIEW_SAMPLE_VALUES.td_first_name,
  td_last_name: PREVIEW_SAMPLE_VALUES.td_last_name,
  agency_first_name: PREVIEW_SAMPLE_VALUES.agency_first_name,
  agency_last_name: PREVIEW_SAMPLE_VALUES.agency_last_name,
  payer_first_name: PREVIEW_SAMPLE_VALUES.payer_first_name,
  payer_last_name: PREVIEW_SAMPLE_VALUES.payer_last_name,
  itinerary_title: PREVIEW_SAMPLE_VALUES.itinerary_title,
  installment_label: PREVIEW_SAMPLE_VALUES.installment_label,
  amount: PREVIEW_SAMPLE_VALUES.amount,
  currency: PREVIEW_SAMPLE_VALUES.currency,
  days_overdue: PREVIEW_SAMPLE_VALUES.days_overdue,
  due_date: PREVIEW_SAMPLE_VALUES.due_date,
  destinations: ['Tokyo', 'Kyoto', 'Osaka'],
  recorded_by_name: PREVIEW_SAMPLE_VALUES.recorded_by_name,
  platform_fee_amount: PREVIEW_SAMPLE_VALUES.platform_fee_amount,
};

/** Valore campione di una variabile; se sconosciuta si mostra il nome stesso. */
export const samplePreviewValue = (variable: string): string =>
  PREVIEW_SAMPLE_VALUES[variable] ?? variable.replace(/_/g, ' ');
